import { EnvType, envType } from "../config/envType";

export const baseUrl = {
  [EnvType.DEV]: "https://api-dev.mynexity.fr",
  [EnvType.PRD]: "https://api-prd.mynexity.fr",
  [EnvType.QUA]: "https://api-qua.mynexity.fr",
}[envType];
